<template>
  <lb-drawer
    :value="visible"
    @input="$emit('update:visible', $event)"
    heading="File Bulk Upload"
    :width="drawerWidths.sm"
    persistent
    v-if="visible"
    data-testid="tasklist__bulk-work-paper-upload-drawer"
  >
    <template v-slot:body>
      <div class="d-flex align-center justify-space-between mb-4">
        <h5>Upload your document</h5>
        <v-btn
          class="secondaryBtn"
          @click="$emit('download-template')"
          data-testid="tasklist__bulk-work-paper-download-template-btn"
        >
          <v-icon>mdi-download</v-icon><span> Download Template</span></v-btn
        >
      </div>
      <DragDropfile
        hidedetails
        :files="files"
        @update:files="$emit('update:files', $event)"
        :resetTrigger="resetTrigger"
        data-testid="tasklist__bulk-work-paper-drag-drop-file"
      />
      <p class="gray--text ma-0 mt-3">Remark (optional)</p>
      <lb-textBox
        requriedrows="3"
        :hidedetails="true"
        :value="fileRemark"
        @input="$emit('update:fileRemark', $event)"
        label="Input"
        data-testid="tasklist__bulk-work-paper-remark-textbox"
      />
      <v-container class="pa-0">
        <v-row no-gutters class="">
          <template v-if="(fileNamesList || []).length > 0">
            <v-col
              v-for="(v, k) in fileNamesList"
              :key="k"
              cols="4"
              class="pa-3 border-on radius-small"
            >
              <v-sheet class="d-flex flex-column">
                <p class="ma-0 black--text font-size-md mb-3">
                  {{ v.uploadname || modifiedName }}
                </p>
                <p class="font-size-xm">{{ v.formattedDate }}</p>
                <div class="mt-4">
                  <v-btn
                    @click="$emit('download-file', v._id)"
                    class="cursor-pointer radius-mini secondaryBtn"
                    text
                    data-testid="tasklist__bulk-work-paper-download-btn"
                  >
                    <v-icon>mdi-download</v-icon>
                    <span>Download</span>
                  </v-btn>
                  <v-spacer />
                </div>
              </v-sheet>
            </v-col>
          </template>
          <v-col v-if="viewTaskRemark" cols="4" class="pa-3 border-on radius-small">
            <p class="ma-0 black--text font-size-md mb-3">Remark</p>
            <p class="font-size-xm">{{ viewTaskRemarkDate }}</p>

            <span>{{ viewTaskRemark }}</span>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-slot:actions>
      <v-checkbox
        label="Upload without document"
        hide-details
        class="ma-0"
        :input-value="uploadWithoutFile"
        @change="$emit('update:uploadWithoutFile', $event)"
        data-testid="tasklist__bulk-work-paper-upload-without-file-checkbox"
      />
      <v-spacer />
      <v-btn
        data-testid="tasklist__bulk-work-paper-submit-btn"
        v-if="uploadWithoutFile"
        class="ml-2 white--text"
        color="primary"
        @click="$emit('submit-without-file')"
        ><span>Submit</span></v-btn
      >
      <v-btn
        v-else
        data-testid="tasklist__bulk-work-paper-submit-btn"
        class="ml-2 white--text"
        color="primary"
        @click="$emit('submit-with-files')"
        ><span>Submit</span></v-btn
      >
    </template>
  </lb-drawer>
</template>

<script>
import DragDropfile from '../../../../../../../views/Inputs/DragDropfile.vue';
import { drawerWidths } from '../../../../../../../styles/design-tokens.js';

export default {
  name: 'BulkWorkpaperUploadDrawer',
  components: {
    DragDropfile,
  },
  data() {
    return { drawerWidths };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    files: {
      type: [Array, Object],
      default: null,
    },
    resetTrigger: {
      type: Boolean,
      default: false,
    },
    fileRemark: {
      type: String,
      default: '',
    },
    fileNamesList: {
      type: Array,
      default: () => [],
    },
    modifiedName: {
      type: String,
      default: '',
    },
    viewTaskRemark: {
      type: String,
      default: '',
    },
    viewTaskRemarkDate: {
      type: String,
      default: '',
    },
    uploadWithoutFile: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
